import {
  FilterMode,
  EditionDocumentTypeCreateMutationVariables,
  EditionDocumentType_OrderBy,
  EditionDocumentType,
  SortOrder,
  EditionDocumentType_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const editionDocumentTypeService = {
  createOne: buildCreateOne(
    (
        editionDocumentTypeCreateVariables: EditionDocumentTypeCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.editionDocumentTypeCreate(
          editionDocumentTypeCreateVariables
        );
        return result.editionDocumentTypeCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.editionDocumentTypeOne({ id });
    return result.editionDocumentTypeOne as EditionDocumentType;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EditionDocumentType_OrderBy[] | null = null,
    filter: EditionDocumentType_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EditionDocumentType_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.editionDocumentTypeListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.editionDocumentTypeListWithOffset
    ) as EditionDocumentType[];
    return { list, orderBy };
  },
};
